import { render, staticRenderFns } from "./ItemizeAdmin.vue?vue&type=template&id=2412765e"
import script from "./ItemizeAdmin.vue?vue&type=script&lang=js"
export * from "./ItemizeAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports